<template>
  <div class="footer">
    <el-row class="container">
      <el-col :xs="4"
              :span="5">
        <div class="title">{{$t('footer.aboutus')}}</div>
        <div class="white-block"></div>
        <div class="content"
             v-on:click="goto('aboutus')">{{$t('footer.aboutus_content1')}}</div>
        <div class="content"
             v-on:click="goto('aboutus', 'declaration')">{{$t('footer.aboutus_content2')}}</div>
        <div class="content"
             v-on:click="goto('aboutus', 'companyHistory')">{{$t('footer.aboutus_content3')}}</div>
      </el-col>
      <el-col :xs="6"
              :span="6">
        <div class="title">{{$t('footer.business')}}</div>
        <div class="white-block"></div>
        <div class="content"
             v-on:click="goto('ev')">{{$t('footer.business_content1')}}</div>
        <div class="content"
             v-on:click="goto('salvageValue')">{{$t('footer.business_content2')}}</div>
        <div class="content"
             v-on:click="goto('secondHand')">{{$t('footer.business_content3')}}</div>
      </el-col>
      <el-col :xs="spanValue.cooperation"
              :span="5">
        <div class="title">{{$t('footer.cooperation')}}</div>
        <div class="white-block"></div>
        <div class="content"
             v-on:click="goto('applyFor')">{{$t('footer.cooperation_content1')}}</div>
        <div v-on:click="goto('cooperation')"
             class="content">{{$t('footer.cooperation_content2')}}</div>
      </el-col>
      <el-col :xs="spanValue.contact"
              :span="8">
        <div class="title">{{$t('footer.contact')}}</div>
        <div class="white-block"></div>
        <div class="content">
          <div style="width: 10%; vertical-align: top;"><i class="el-icon-map-location"></i></div>
          <div style="width: 80%"><a target="_blank"
               href="https://uri.amap.com/marker?position=121.43426,31.157514&name=徐锦记大厦">{{$t('footer.contact_address')}}</a></div>
        </div>
        <div class="content">
          <div style="width: 10%; vertical-align: top;"><i class="el-icon-phone-outline"></i></div>
          <div style="width: 80%">{{$t('footer.contact_phone')}}</div>
        </div>
        <div class="content">
          <div style="width: 10%; vertical-align: top;"><i class="el-icon-message"></i></div>
          <div style="width: 80%; word-break: nowrap;">{{$t('footer.contact_email')}}</div>
        </div>
      </el-col>
    </el-row>
    <div class="white_block"></div>
    <div class="beian"
         style="padding-top: 10px;">
      <a target="_blank"
         style="display:inline-block;text-decoration:none;">
        <img src="@/assets/images/beian.png"
            @click="goRecord"
             style="float:left; width: 0.2rem;" />
        <p @click="goRecord" style="float:left;height:0.2rem;line-height:0.2rem;margin: 0px 5px 0px 5px; font-size: 0.16rem; color:#939393;">沪ICP备案15009255号</p>
        <img @click="goRecord2" src="@/assets/images/beian2.jpg"
             style="float:left; width: 0.2rem;" />
      </a>
    </div>
    <div class="beian">
      <!-- <a target="_blank"
         href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402005783"
         style="display:inline-block;text-decoration:none;"> -->
      <a target="_blank"
      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402005783"
      style="display:inline-block;text-decoration:none;">
        <img src="@/assets/images/beian.png"
             style="float:left; width: 0.2rem;" />
        <p style="float:left;height:0.2rem;line-height:0.2rem;margin: 0px 0px 0px 5px; font-size: 0.16rem; color:#939393;">沪公网安备 31010402005783号</p>
      </a>
    </div>
    <div class="beian">
      <span style="height:0.2rem;line-height:0.2rem;margin: 0px 0px 0px 5px; font-size: 0.16rem; color:#939393;">2009 - 2022好车伯乐隶属于上海优与汽车科技有限公司 版权所有</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(newValue) {
      if (newValue === 'en') {
        this.spanValue = {
          cooperation: 5,
          contact: 9
        }
      }
    }
  },
  data() {
    return {
      spanValue: {
        cooperation: 4,
        contact: 10
      }
    }
  },
  methods: {
    goto(path, id) {
      if (id) {
        this.$router.push({ path, query: { id } })
      } else {
        this.$router.push({ path })
      }
    },
    goRecord() {
      let httpUrl = window.location.host
      // if (httpUrl.indexOf('.com') !== -1) {
      //   window.open('http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a77606&signData=MEUCIAXxPP0llzFGnK5nQ6QHn0ghattS42kcpo/IY3S9Qt94AiEA/cI7W0fADQ/m+IqgIXP3lI2K/Wlx0A55vy3w4DPJqUw=')
      // } else if (httpUrl.indexOf('.net') !== -1) {
      //   window.open('http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a78206&signData=MEQCIGI58PQSa/CxnAKrmYGrcKOCuhsv6H5Sh3MzdVpz37QMAiATtQqqiGvdad2EPz+yhDwoHrmH+//y9SnsioIfMkXvPA==')
      // } else {
      //   window.open('http://218.242.124.22:8081/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a78206&signData=MEQCIGI58PQSa/CxnAKrmYGrcKOCuhsv6H5Sh3MzdVpz37QMAiATtQqqiGvdad2EPz+yhDwoHrmH+//y9SnsioIfMkXvPA==')
      // }
      if (httpUrl.indexOf('.com') !== -1) {
        window.open('https://beian.miit.gov.cn/')
      } else if (httpUrl.indexOf('.net') !== -1) {
        window.open('https://beian.miit.gov.cn/')
      } else {
        window.open('https://beian.miit.gov.cn/')
      }
    },
    goRecord2() {
      let httpUrl = window.location.host
      if (httpUrl.indexOf('.com') !== -1) {
        window.open('http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a77606&signData=MEUCIAXxPP0llzFGnK5nQ6QHn0ghattS42kcpo/IY3S9Qt94AiEA/cI7W0fADQ/m+IqgIXP3lI2K/Wlx0A55vy3w4DPJqUw=')
      } else if (httpUrl.indexOf('.net') !== -1) {
        window.open('http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a78206&signData=MEQCIGI58PQSa/CxnAKrmYGrcKOCuhsv6H5Sh3MzdVpz37QMAiATtQqqiGvdad2EPz+yhDwoHrmH+//y9SnsioIfMkXvPA==')
      } else {
        window.open('http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020170516153651000001783754-SAIC_SHOW_310000-4028e4cb5e3740e2015e7b5bf0cc3a78206&signData=MEQCIGI58PQSa/CxnAKrmYGrcKOCuhsv6H5Sh3MzdVpz37QMAiATtQqqiGvdad2EPz+yhDwoHrmH+//y9SnsioIfMkXvPA==')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: black;
  font-size: 0.2rem;

  .container {
    width: 12rem;
    color: #fff;
    margin: 0 auto;
    text-align: left;
    // border-bottom: 0.02rem solid #525252;
    .el-col {
      padding: 0.35rem 0.3rem;
    }
    .white-block {
      border-top: 0.02rem solid #fff;
      width: 0.22rem;
      height: 0.12rem;
    }
    .title {
      font-size: 0.18rem;
      font-weight: 500;
      line-height: 0.24rem;
      padding: 0.12rem 0rem;
    }
    .content {
      font-size: 0.16rem;
      font-weight: 400;
      color: rgba(203, 203, 203, 1);
      line-height: 0.24rem;
      padding: 0.12rem 0rem;
      cursor: pointer;
      div {
        display: inline-block;
      }

      a {
        font-size: 0.16rem;
        font-weight: 400;
        color: rgba(203, 203, 203, 1);
        line-height: 0.24rem;
      }
    }
  }

  .beian {
    padding: 2px 0;
  }

  .white_block {
    height: 1px;
    width: 100%;
    background: #525252;
  }

  @media only screen and (max-width: 750px) {
    .container {
      width: 100%;
      padding-left: 0.15rem;
      .el-col {
        padding: 0.35rem 0.1rem;
      }
    }
  }
}
</style>
